// users.js (em migração do global.js)
// Constantes compartilhadas entre instâncias de pessoas (Membros, Colaboradores, Professores)

import { getOptionsFromMap } from './common';

export const MARITAL_STATUS = {
    SINGLE: 'single',
    MARRIED: 'married',
    DIVORCED: 'divorced',
    WIDOWED: 'widowed',
    STABLE_UNION: 'stable_union'
};

export const MARITAL_STATUS_LABELS = {
    [MARITAL_STATUS.SINGLE]: 'Solteiro(a)',
    [MARITAL_STATUS.MARRIED]: 'Casado(a)',
    [MARITAL_STATUS.DIVORCED]: 'Divorciado(a)',
    [MARITAL_STATUS.WIDOWED]: 'Viúvo(a)',
    [MARITAL_STATUS.STABLE_UNION]: 'União Estável'
};

export const MARITAL_STATUS_OPTIONS = getOptionsFromMap(MARITAL_STATUS, MARITAL_STATUS_LABELS);

export const CONTACT_TYPES = {
    PHONE: 1,
    MOBILE: 2,
    EMAIL: 4,
    WHATSAPP: 8,
    OTHER: 12
};

export const CONTACT_LABELS = {
    [CONTACT_TYPES.PHONE]: 'Telefone',
    [CONTACT_TYPES.MOBILE]: 'Celular',
    [CONTACT_TYPES.EMAIL]: 'E-mail',
    [CONTACT_TYPES.WHATSAPP]: 'WhatsApp',
    [CONTACT_TYPES.OTHER]: 'Outro'
};

export const CONTACT_TYPE_OPTIONS = getOptionsFromMap(CONTACT_TYPES, CONTACT_LABELS);

export const DOCUMENT_TYPES = {
    CPF: 1,
    RG: 2,
    OTHERS: 0
};

export const DOCUMENT_LABELS = {
    [DOCUMENT_TYPES.CPF]: 'CPF',
    [DOCUMENT_TYPES.RG]: 'RG',
    [DOCUMENT_TYPES.OTHERS]: 'Outro'
};

export const DOCUMENT_TYPE_OPTIONS = getOptionsFromMap(DOCUMENT_TYPES, DOCUMENT_LABELS);
